import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid, Table, TableHead, TableRow, TableCell, TableBody, Checkbox } from '@mui/material';
import { Dialog, Button } from '@totalsoft/rocket-ui';
import { onCheckBoxChange } from 'utils/propertyChangeAdapters';
import { BoxActionsWrapper } from 'components/common/CommonStyles';

const OfferAddPartnersFromHierarchyComponent = ({ showModal, t, onCloseModal, partnersList, addPartners, onPartnerSelected }) => {
  return (
    <>
      <Dialog
        open={showModal}
        onClose={onCloseModal}
        aria-labelledby='availableUploadDocuments-dialog-title'
        maxWidth='xl'
        fullWidth
        title={t('OfferEdit.HierarchyPartners.Title')}
        content={
          <Grid item xs={12}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell>{t('OfferEdit.Client.PJ.CompanyName')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {partnersList.map((partner, idx) => {
                  return (
                    <TableRow key={partner.partnerId}>
                      <TableCell>
                        <Checkbox checked={partner.selected || false} onChange={onCheckBoxChange(onPartnerSelected(idx))} value='1' />
                      </TableCell>
                      <TableCell>{partner.partnerName}</TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Grid>
        }
        actions={
          <BoxActionsWrapper forDialog>
            <Button onClick={addPartners}>{t('Add')}</Button>
            <Button onClick={onCloseModal}>{t('Close')}</Button>
          </BoxActionsWrapper>
        }
      />
    </>
  );
};

OfferAddPartnersFromHierarchyComponent.propTypes = {
  showModal: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  partnersList: PropTypes.array.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  addPartners: PropTypes.func.isRequired,
  onPartnerSelected: PropTypes.func.isRequired
};

export default withTranslation()(OfferAddPartnersFromHierarchyComponent);
